import { ChevronDown, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'
import { TimelineSectionHeading } from '../person-timeline-modal'

interface CollapsibleCountTableProps {
	title: string
	columnLabel: string
	items: { id: string; name: string; count: number }[]
	defaultCollapsed?: boolean
}

export function CollapsibleCountTable({
	title,
	columnLabel,
	items,
	defaultCollapsed = true,
}: CollapsibleCountTableProps) {
	const [collapsed, setCollapsed] = useState(defaultCollapsed)

	return (
		<div>
			<button
				type="button"
				className="flex w-full items-center gap-1"
				onClick={() => setCollapsed((current) => !current)}
			>
				{collapsed ? (
					<ChevronRight className="size-3.5 shrink-0 text-muted-foreground" />
				) : (
					<ChevronDown className="size-3.5 shrink-0 text-muted-foreground" />
				)}
				<TimelineSectionHeading>{title}</TimelineSectionHeading>
			</button>

			{!collapsed &&
				(items.length === 0 ? (
					<p className="mt-1 text-xs text-muted-foreground">Sem registros.</p>
				) : (
					<div className="mt-1 rounded-lg border border-kaefer-light-silver">
						<Table className="table-fixed">
							<TableHeader>
								<TableRow className="bg-muted/30">
									<TableHead>{columnLabel}</TableHead>
									<TableHead className="w-20 text-right">Total</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{items.map((item) => (
									<TableRow key={item.id}>
										<TableCell className="whitespace-normal wrap-break-word">
											{item.name}
										</TableCell>
										<TableCell className="text-right">{item.count}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				))}
		</div>
	)
}
